import { render, staticRenderFns } from "./TerminalRental.vue?vue&type=template&id=56cc00d1"
import script from "./TerminalRental.vue?vue&type=script&lang=js"
export * from "./TerminalRental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports